module.exports = __webpack_public_path__ + "static/media/men.c41770e4.jpg";